import React from "react";
import { CALLOUT_STROKE_WIDTH, HITBOX_PADDING } from "../constants";
import { getCalloutLeaderGeometry, toSvgPoints } from "../utils";

const HANDLE_SIZE = 8;

const RESIZE_CORNERS = [
  { handle: "nw", cursor: "nwse-resize", x: 0, y: 0 },
  { handle: "ne", cursor: "nesw-resize", x: 1, y: 0 },
  { handle: "sw", cursor: "nesw-resize", x: 0, y: 1 },
  { handle: "se", cursor: "nwse-resize", x: 1, y: 1 },
];

const CalloutLeader = ({
  tip,
  knee,
  box,
  color = "red",
  dashed = false,
  showHandles = false,
  leaderHitProps,
  tipHitProps,
  kneeHitProps,
}) => {
  if (!tip || !box) return null;
  const geometry = getCalloutLeaderGeometry(tip, box, knee);
  const points = geometry ? toSvgPoints(geometry.points) : null;
  const kneePoint = geometry ? geometry.points[1] : null;
  const dash = dashed ? "5,5" : undefined;

  return (
    <g>
      <rect
        x={box.left}
        y={box.top}
        width={box.width}
        height={box.height}
        fill="none"
        stroke={color}
        strokeWidth={CALLOUT_STROKE_WIDTH}
        strokeDasharray={dash}
        style={{ pointerEvents: "none" }}
      />
      {geometry && (
        <>
          {leaderHitProps && (
            <polyline
              points={points}
              stroke="transparent"
              strokeWidth={HITBOX_PADDING}
              fill="none"
              {...leaderHitProps}
            />
          )}
          <polyline
            points={points}
            stroke={color}
            strokeWidth={CALLOUT_STROKE_WIDTH}
            strokeDasharray={dash}
            strokeLinejoin="round"
            fill="none"
            style={{ pointerEvents: "none" }}
          />
          <polygon
            points={toSvgPoints(geometry.arrow)}
            fill={color}
            style={{ pointerEvents: "none" }}
          />
        </>
      )}
      {tipHitProps && (
        <circle cx={tip.x} cy={tip.y} r={HITBOX_PADDING} fill="transparent" {...tipHitProps} />
      )}
      {showHandles && kneePoint && kneeHitProps && (
        <circle
          cx={kneePoint.x}
          cy={kneePoint.y}
          r={HITBOX_PADDING}
          fill="transparent"
          {...kneeHitProps}
        />
      )}
      {showHandles && (
        <circle
          cx={tip.x}
          cy={tip.y}
          r={5}
          fill="white"
          stroke="#1890ff"
          strokeWidth={1.5}
          style={{ pointerEvents: "none" }}
        />
      )}
      {showHandles && kneePoint && kneeHitProps && (
        <rect
          x={kneePoint.x - 4}
          y={kneePoint.y - 4}
          width={8}
          height={8}
          transform={`rotate(45 ${kneePoint.x} ${kneePoint.y})`}
          fill={knee ? "#1890ff" : "white"}
          stroke="#1890ff"
          strokeWidth={1.5}
          style={{ pointerEvents: "none" }}
        />
      )}
    </g>
  );
};

export const CalloutResizeHandles = ({ box, getHandleProps }) => (
  <g>
    {RESIZE_CORNERS.map(({ handle, cursor, x, y }) => {
      const { style, ...rest } = getHandleProps(handle);
      return (
        <rect
          key={handle}
          x={box.left + x * box.width - HANDLE_SIZE / 2}
          y={box.top + y * box.height - HANDLE_SIZE / 2}
          width={HANDLE_SIZE}
          height={HANDLE_SIZE}
          fill="white"
          stroke="#1890ff"
          strokeWidth={1.5}
          style={{ ...style, cursor }}
          {...rest}
        />
      );
    })}
  </g>
);

export default CalloutLeader;
